import type { ReactNode } from 'react';

export const symbol_air: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M461-160q-38 0-69-22t-41-59q-3-13 6.5-23t23.5-10q11 0 19 7.5t13 18.5q6 14 19.5 21t28.5 7q23 0 38.5-15.5T515-274q0-23-15.5-38.5T461-328H110q-13 0-21.5-8.5T80-358q0-13 8.5-21.5T110-388h351q48 0 81 33t33 81q0 48-33 81t-81 33ZM110-568q-13 0-21.5-8.5T80-598q0-13 8.5-21.5T110-628h513q32 0 54-22t22-54q0-32-22-54t-54-22q-23 0-42 12t-26 33q-4 11-12.5 19t-19.5 8q-14 0-22.5-9.5T495-740q11-45 46.5-72.5T623-840q57 0 96.5 39.5T759-704q0 57-39.5 96.5T623-568H110Zm670 321q-13 2-22.5-6.5T748-276q0-11 8-19.5t19-12.5q22-7 33.5-26t11.5-42q0-30-21-51t-51-21H110q-13 0-21.5-8.5T80-478q0-13 8.5-21.5T110-508h638q55 0 93.5 38.5T880-376q0 47-27.5 83T780-247Z"
		/>
	</svg>
);
